import InfoStyle from "../styles&pics/InfoStyle";
import { useState, useEffect } from "react";
import TypingText from "../UtilityComponents/TypingText";
import InfoButton from "./InfoButton";
import FastTypingText from "../UtilityComponents/FastTypingText";
import TextToVar from "./TextToVar";

export const Info = () => {
  const [showWelcome, setShowWelcome] = useState(true);
  const [startTyping, setStartTyping] = useState(false); // State to control typing animation
  const [startWTyping, setWStartTyping] = useState(true); 
  const [selectedSection, setSelectedSection] = useState("");
  const [toggleTyping, setToggleType] = useState(true);


  

  const toggleType = () => {
    setToggleType(!toggleTyping);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
      setWStartTyping(false);
      setStartTyping(true); // Start typing animation after welcome message fades out
    }, 3000); // Reduced from 9000 to 3000 (3 seconds)
    return () => clearTimeout(timer);
  }, []);

  // Function to handle section toggle
  const toggleSection = (section) => {
    setSelectedSection(section === selectedSection ? "" : section);// Toggle selected section
    setToggleType(true);
  };
const gpdrText=TextToVar({infotext:"gpdr"})
const versionNotesText=TextToVar({infotext:"versionnotes"})
const generalText=TextToVar({infotext:"general"})
const process=TextToVar({infotext:"process"})
 

  return (
    <>
      <InfoStyle />
      <main className="info-main">
        <div className={showWelcome ? "welcome" : "sections"}>
          <p2>
            {(startWTyping && showWelcome) && (
              <TypingText text={"Καλωσήρθατε στις πληροφορίες!\nΦόρτωση δεδομένων..."} />
            )}
            {startTyping && (
              <TypingText
                text={"Παρακαλώ επιλέξτε τον τομέα που θέλετε να ενημερωθείτε"}
              />
            )}
          </p2>
          <br /><br />
          {showWelcome && (
            <span className="infoloader"></span>
          )}
        </div>
        <div className="section-list">
          <ul>
            <li><InfoButton value={"Γενικές Πληροφορίες"} toggle={toggleSection} /></li>
            <li><InfoButton value={"Διαδικασία Διορθώσεων"} toggle={toggleSection} /></li>
            <li><InfoButton value={"Version notes"} toggle={toggleSection} /></li>
            <li><InfoButton value={"GPDR"} toggle={toggleSection} /></li>
          </ul>
        </div>
        <br />
        <div style={{ textAlign: "center" }}>{selectedSection!=="" && <button className="type-button" onClick={() => toggleType()}>{toggleTyping ? "Εμφάνιση Πλήρη Κειμένου" : "Type it!"}</button>}</div>
        {selectedSection && (
          <div className="info-section">
            {selectedSection === "Γενικές Πληροφορίες" && (
              <div className="infobox">
                <div style={{ textAlign: "left" }}><p1><FastTypingText text={"◼ ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ"}  /></p1></div>
                <br />{toggleTyping?<p><FastTypingText text={generalText}  /></p>:  <p>
                {generalText.split('\n').map((line, index) => (
                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}>{line}</div>
              ))}
              </p>}
              </div>
            )}
            {selectedSection === "Διαδικασία Διορθώσεων" && (
              <div className="infobox">
                <div style={{ textAlign: "left" }}><p1><FastTypingText text={"◼ ΔΙΑΔΙΚΑΣΙΑ ΔΙΟΡΘΩΣΕΩΝ"}  /></p1></div>
                <br />{toggleTyping?<p><FastTypingText text={process}  /></p>:  <p>
                {process.split('\n').map((line, index) => (
                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}>{line}</div>
              ))}
              </p>}
              </div>
            )}
            {selectedSection === "Version notes" && (
              <div className="infobox">
                <div style={{ textAlign: "left" }}><p1><FastTypingText text={"◼ VERSION NOTES"}  /></p1></div>
                <br />{toggleTyping?<p><FastTypingText text={versionNotesText}  /></p>:  <p>
                {versionNotesText.split('\n').map((line, index) => (
                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}>{line}</div>
              ))}
              </p>}
              </div>
            )}
            {selectedSection === "GPDR" && (
              <div className="infobox">
                <div style={{ textAlign: "left" }}><p1><FastTypingText text={"◼ GPDR"}  /></p1></div>
                <br />{toggleTyping?<p><FastTypingText text={gpdrText}  /></p>:  <p>
                {gpdrText.split('\n').map((line, index) => (
                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}>{line}</div>
              ))}
              </p>}
              </div>
            )}
          </div>
        )}
      </main>
    </>
  );
};